// Set cookie
export const setCookie = (
  name: string,
  value: string,
  maxAge: number
) => {
  document.cookie = `${name}=${value}; path=/; max-age=${maxAge}`
}

// Delete cookie
export const deleteCookie = (name: string) => {
  document.cookie = `${name}=; path=/; max-age=0`
}

// Get cookie
export const getCookie = (name: string) => {
  const match = document.cookie.match(
    new RegExp('(^| )' + name + '=([^;]+)')
  )
  return match ? decodeURIComponent(match[2]) : null
}